import { children, id } from "./power";
import { deleteNull } from "@src/utils";
const power = {
    ...children,
    ...{ [id.id]: id }
};

export default class PrimeCostApi {
    /**
     *
     * @param {any} params
     * @returns
     * @memberOf PrimeCostApi
     */
    [power[id.id].apiName](params) {
        let url = power[id.id].url;
        return this.POST(url, deleteNull(params));
    }

    [power.ADD_DATA.apiName](params) {
        let url = power.ADD_DATA.url;
        return this.POST(url, deleteNull(params));
    }

    [power.EDIT_DATA.apiName](params) {
        let url = power.EDIT_DATA.url;
        return this.POST(url, deleteNull(params));
    }

    [power.DEL_DATA.apiName](params) {
        let url = power.DEL_DATA.url + `/${params.id}`;
        return this.GET(url, deleteNull(params));
    }

    [power.CONFIRM_DATA.apiName](params) {
        let url = power.CONFIRM_DATA.url + `/${params.id}`;
        return this.GET(url, deleteNull(params));
    }

    [power.CANCEL_DATA.apiName](params) {
        let url = power.CANCEL_DATA.url + `/${params.id}`;
        return this.GET(url, deleteNull(params));
    }

    [power.BILLS_CONFIRM.apiName](params) {
        //确定生成对账单
        let url = power.BILLS_CONFIRM.url;
        return this.POST(url, params);
    }
}
